import axios from "@/api/axiosInstance";
import { FetchRosterManagementReportParams } from "./types";

export const fetchRosterManagementReportCsv = async (
  params: Omit<FetchRosterManagementReportParams, "page" | "pageSize"> = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/reports/roster-management/export",
    { responseType: "blob", params },
  );
  return response.data;
};
